module.exports = __webpack_public_path__ + "img/loyalty_core.37f6b561.svg";